var React = require('react');

function LocationSimple (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Group","fill":"#4F4F4F"},[React.createElement("path",{"d":"M11,7 C8.79,7 7,8.79 7,11 C7,13.21 8.79,15 11,15 C13.21,15 15,13.21 15,11 C15,8.79 13.21,7 11,7 Z","id":"path-1-path","key":0}),React.createElement("path",{"d":"M12,2.06 C16.17,2.52 19.48,5.83 19.94,10 L22,10 L22,12 L19.94,12 C19.48,16.17 16.17,19.48 12,19.94 L12,22 L10,22 L10,19.94 C5.83,19.48 2.52,16.17 2.06,12 L0,12 L0,10 L2.06,10 C2.52,5.83 5.83,2.52 10,2.06 L10,0 L12,0 L12,2.06 Z M4,11 C4,14.87 7.13,18 11,18 C14.87,18 18,14.87 18,11 C18,7.13 14.87,4 11,4 C7.13,4 4,7.13 4,11 Z","id":"Combined-Shape","key":1})]))]);
}

LocationSimple.defaultProps = {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1"};

module.exports = LocationSimple;

LocationSimple.default = LocationSimple;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/location-simple.svg
// module id = 1496
// module chunks = 0